module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-42.7a710e1e.png";